import React from 'react';
import PropTypes from 'prop-types';
import './Trends.css';

import GridSimple from '../content/grid/GridSimple';
import CardArtistLabel from './CardArtistLabel';
import SubMenu from '../common/SubMenu';

import useExtract from '../../../hooks/useExtract';

// TODO - navigation arrows + controller

function TrendsV2({ width, pathApi, params, className, style, exceptIds = null, }) {
  const data = useExtract(pathApi, params, exceptIds ? [exceptIds] : []);
  const components = {
    'artists': CardArtistLabel,
    'labels': CardArtistLabel,
    'genres': SubMenu,
  };
  
  return data ? (
    <div className={`extract-container ${className}`} style={{...style, overflowX: 'hidden'}}>
      { data.map( trend => {

        const data = trend.forceData ? trend.forceData : trend.data
        const rowPadding = (trend.grid.rowPadding) ? trend.grid.rowPadding : 0;
        const coverBorder = (trend.grid.coverBorder) ? trend.grid.coverBorder : 0;
        const nbVisible = Math.floor(width / trend.grid.rowWidth);
        const gap = (trend.grid.gap) ? trend.grid.gap : 0;
        const nbShowing = (trend.grid.showAll) ? data.length :  Math.floor((width - ((nbVisible - 2) * gap)) / trend.grid.rowWidth);;

        return (
          <GridSimple
            key={`trends-v2-${trend.id}-${nbShowing}`}
            title={trend.title}
            data={data}
            height={trend.rowHeight}
            className={trend.className}
            gridClassName={trend.grid.className}
            gridStyle={{gap, position: 'relative'}}
            hasPagination={trend.grid.hasPagination}
            pagLimit={nbShowing}
            element={ (components[trend.type]) ? React.createElement(components[trend.type], {
              style: (trend.type !== 'genres') ? { width: trend.grid.rowWidth - (rowPadding * 2), height: trend.grid.rowHeight, padding: rowPadding } : {},
              width: trend.grid.rowWidth - ((rowPadding + coverBorder) * 2),
              className: trend.grid.blockClassName,
              coverClassName: trend.grid.coverClassName
            }) : null }
          />
        )
      } ) }
    </div>
  ) : null;
}

TrendsV2.propTypes = {
  width: PropTypes.number.isRequired,
  pathApi: PropTypes.string.isRequired,
  params: PropTypes.array.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

export default TrendsV2
